<div *ngIf="transport && transportConfiguration">
  <div class="row" *ngIf="isAuthenticated && isUser">
    <div class="col-12">
      <jhi-estimation-my-addresses
        [transportForm]="transportForm"
        [(selectedAddress)]="selectedAddress"
        [isPickup]="false"
        (selectedAddressChange)="selectRegisteredAddress(selectedAddress)"
      ></jhi-estimation-my-addresses>
    </div>
  </div>

  <div class="row card-group">
    <div class="col-12 col-md-6" *ngIf="!selectedAddress">
      <div class="row h-100">
        <div class="col-12 flex-grow-1">
          <jhi-address-card
            id="delivery.company.address"
            [addressForm]="transportForm.controls.deliveryAddress"
            [options]="{ withBillAddress: false, withFullName: true, withAdditional: true }"
          ></jhi-address-card>
        </div>
        <div class="col-12 mt-3">
          <jhi-bary-card *ngIf="transportForm">
            <form autocomplete="off" body>
              <div class="row mt-0">
                <div class="col-12 option-selector-no-wrap">
                  <jhi-loading-constraint
                    [transport]="transport"
                    [control]="transportForm.controls.deliveryLoadingConstraint"
                    [config]="transportConfiguration"
                    [options]="{ isPickup: false }"
                    (selectedLoadingConstraint)="selectLoadingConstraint($event)"
                  ></jhi-loading-constraint>
                </div>
              </div>
              <div class="row mt-3" *ngIf="!transport.isFTL()">
                <div class="col-12 option-selector-no-wrap">
                  <jhi-access-constraint
                    [transport]="transport"
                    [control]="transportForm.controls.deliveryAccessConstraint"
                    [config]="transportConfiguration"
                    [options]="{ isPickup: false }"
                    (selectedAccessConstraint)="selectAccessConstraint($event)"
                  ></jhi-access-constraint>
                </div>
              </div>
            </form>
          </jhi-bary-card>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 h-100" *ngIf="selectedAddress">
      <jhi-bary-card titleKey="ESTIMATION_TUNNEL.LABEL.KNOWN_ADDRESS">
        <jhi-selected-registered-address
          body
          [address]="selectedAddress"
          [referenceControl]="transportForm.controls.deliveryReference"
          [isPickup]="true"
          (closeEvent)="this.selectedAddress = undefined"
        ></jhi-selected-registered-address>
      </jhi-bary-card>
    </div>
    <div class="col-12 col-md-6">
      <div class="row">
        <div class="col-12">
          <jhi-transport-parameters-card
            [transportForm]="transportForm"
            [transportConfiguration]="transportConfiguration!"
            [transporter]="transporter!"
            id="delivery-parameters"
            [options]="{ isPickup: false }"
          ></jhi-transport-parameters-card>
        </div>
        <div class="col-12 mt-3">
          <jhi-contact-card
            id="delivery.company.address"
            referenceLabel="REGISTERED_ADDRESS.DELIVERY_REF"
            [referenceControl]="transportForm.controls.deliveryReference"
            [contactForm]="transportForm.controls.deliveryContact"
          ></jhi-contact-card>
        </div>
      </div>
    </div>
  </div>
</div>
